import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      background: "#E9FDFF",
      margin: 0,
      padding: 10
    },
    fileLineReadOnly: {
      paddingTop: "12px !important",
      paddingBottom: "12px !important"
    },
    filename: {
      display: "flex",
      alignItems: "center",
      gap: 5
    },
    filenameEditable: {
      background: theme.palette.grey[200],
      padding: "5px 12px",
      borderRadius: 4,
      height: 38
    },
    filenameError: {
      background: theme.palette.scgPrimary.hover
    },
    fileErrorTex: {
      color: theme.palette.error.light,
      fontSize: 12,
      marginTop: 5
    },
    fileTitle: {
      flex: 1,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis"
    },
    fileIcon: {
      height: "18px",
      width: "18px"
    },
    closeIcon: {
      height: "12px",
      width: "12px",
      cursor: "pointer"
    },
    selectField: {
      height: 36,
      "& .MuiSelect-root": {
        padding: "0.8rem 1.2rem",
        color: theme.palette.grey[800]
      }
    },
    radioGroup: {
      flexDirection: "row",
      gap: 15,
      marginTop: 6,
      "& .MuiFormControlLabel-root": {
        margin: 0
      },
      "& .MuiIconButton-root": {
        padding: 0
      }
    }
  }),
  { name: "DocumentList" }
);

export default useStyles;
